"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickAway = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const useClickAway_1 = require("../../hooks/useClickAway");
const ClickAway = ({ as = 'div', onElement, onClickAway, ...rest }) => {
    const clickAwayRef = (0, useClickAway_1.useClickAway)(onClickAway);
    const ref = React.useCallback((el) => {
        if (onElement)
            onElement(el);
        if (clickAwayRef)
            clickAwayRef(el);
    }, [clickAwayRef, onElement]);
    return React.createElement(as, { ref, ...rest });
};
exports.ClickAway = ClickAway;
